
import './Dashboard.css';
import TaxYearNavTab from './TaxYearNavTab';
import classNames from 'classnames';

const TaxYearBar = (props) => {

    return (
        <div className={classNames('taxyear-bar-container', props.layoutType, { 'no-taxyear-tabs': !props.showTaxYears })}> 
            {props.showTaxYears && props.taxStates.map(x => <TaxYearNavTab key={x.taxYear} taxState={x} />)}
        </div>
    )
}

export default TaxYearBar
